import Videos from "../../../components/Admin/Videos";
import Navbar from "../../../components/Navbar";

export default function VideosPage() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <Videos />
        </div>
      </section>
    </>
  );
}
